import { createSlice } from '@reduxjs/toolkit';

const buttonSlice = createSlice({
  name: 'button',
  initialState: {
    isVisible: false, // Initial state (button hidden)
  },
  reducers: {
    showButton: (state) => {
      state.isVisible = true;
    },
    hideButton: (state) => {
      state.isVisible = false;
    },
    toggleButton: (state) => {
      state.isVisible = !state.isVisible;
    },
  },
});

export const { showButton, hideButton, toggleButton } = buttonSlice.actions;
export default buttonSlice.reducer;
